import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { useToast } from "./ToastProvider";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  const { showToast } = useToast();

  const handleShare = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    showToast("分享功能演示中，待接入");
  };

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/60 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/60"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={movie.poster}
          alt={`${movie.title}（${movie.year}）电影海报`}
          title={`${movie.title} - 鸭王在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/10 to-transparent opacity-80"></div>

        {typeof rank === "number" && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-bold text-background-950">
            {rank}
          </span>
        )}

        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-950/75 px-2 py-1 text-xs font-medium text-accent-400">
          <i className="ri-star-fill text-xs"></i>
          {movie.rating.toFixed(1)}
        </span>

        <span className="absolute bottom-2 left-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs text-background-50">
          {movie.year}
        </span>

        <button
          type="button"
          onClick={handleShare}
          className="absolute bottom-2 right-2 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background-950/70 text-foreground-950 opacity-0 transition-opacity group-hover:opacity-100"
          aria-label="分享"
        >
          <i className="ri-share-forward-line text-sm"></i>
        </button>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-950">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
      </div>

      <div className="p-3">
        <h3 className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-accent-500 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-600">
          {movie.year} · {movie.genres.join(" / ")}
        </p>
      </div>
    </Link>
  );
}